export default __webpack_public_path__ + "static/media/man-resume-document.c088cf5c.png";